// Citirex verticals data — placeholder marketing copy
export const VERTICALS = [
  {
    slug: "auto-insurance",
    index: "01",
    name: "Auto Insurance",
    short: "Auto",
    tagline: "High-intent drivers, ready to switch.",
    description:
      "Real-time auto insurance leads from drivers actively shopping for better rates. Pre-qualified by state, ZIP, current carrier, vehicle count and driving record — delivered seconds after submission.",
    heroImage:
      "https://images.pexels.com/photos/3422964/pexels-photo-3422964.jpeg",
    icon: "Car",
    stats: [
      { value: "2.4M", label: "Annual lead volume" },
      { value: "38%", label: "Avg. contact rate" },
      { value: "<60s", label: "Delivery latency" },
      { value: "50", label: "US states covered" },
    ],
    filters: [
      "State & ZIP",
      "Current carrier",
      "Vehicles owned",
      "Drivers per policy",
      "Driving record (clean / SR-22)",
      "Homeowner status",
      "Credit tier",
    ],
    methodology: [
      "Owned-and-operated comparison properties capture intent at the moment of search.",
      "Dynamic forms qualify drivers against your appetite — no wasted spend on records you don't write.",
      "Hot transfers, posted leads, and exclusive data licensed by buyer preference.",
    ],
    quote: {
      text: "Citirex consistently outperforms our top three legacy vendors on bind rate. The auto vertical is our cleanest acquisition channel.",
      author: "VP of Acquisition",
      company: "Top-25 P&C Carrier",
    },
  },
  {
    slug: "home-insurance",
    index: "02",
    name: "Home Insurance",
    short: "Home",
    tagline: "Homeowners shopping policy at the right moment.",
    description:
      "Homeowners actively comparing carriers — segmented by dwelling type, year built, claims history and bundling intent. Built for HO-3, HO-5 and high-value home appetites.",
    heroImage:
      "https://images.pexels.com/photos/16631149/pexels-photo-16631149.jpeg",
    icon: "House",
    stats: [
      { value: "780K", label: "Annual lead volume" },
      { value: "42%", label: "Bundle-ready %" },
      { value: "$420K", label: "Avg. dwelling value" },
      { value: "48", label: "US states covered" },
    ],
    filters: [
      "Dwelling type & year built",
      "Claims in last 5 years",
      "Roof age & material",
      "Distance to coast",
      "Current carrier",
      "Bundle intent (auto)",
      "Wildfire / wind zone",
    ],
    methodology: [
      "Vertical-specific landing pages targeted to homeowners renewing or switching.",
      "Real-time appetite matching against carrier underwriting guidelines.",
      "Bundle-ready leads cross-flagged for auto for higher LTV.",
    ],
    quote: {
      text: "We finally found a partner who actually understands non-standard home appetite. Quality is night-and-day.",
      author: "Director of Marketing",
      company: "Regional Home & Auto Carrier",
    },
  },
  {
    slug: "life-insurance",
    index: "03",
    name: "Life Insurance",
    short: "Life",
    tagline: "Buyers researching coverage for the people they love.",
    description:
      "Term, whole and IUL prospects with stated coverage need, health class indication and budget — qualified for direct-to-consumer agencies and IMO downlines.",
    heroImage:
      "https://images.pexels.com/photos/7927998/pexels-photo-7927998.jpeg",
    icon: "Heart",
    stats: [
      { value: "1.1M", label: "Annual lead volume" },
      { value: "30-65", label: "Core age range" },
      { value: "62%", label: "Phone-verified" },
      { value: "$500K", label: "Median coverage ask" },
    ],
    filters: [
      "Age band & gender",
      "Coverage amount sought",
      "Term / whole / IUL preference",
      "Tobacco use",
      "Self-reported health class",
      "Household income",
      "State licensing match",
    ],
    methodology: [
      "Educational long-form content drives qualified, high-intent traffic.",
      "Pre-screen knockouts remove unwritable risks before delivery.",
      "Hot transfers routed live to your licensed agents in matching states.",
    ],
    quote: {
      text: "Hot transfers from Citirex close at almost double our outbound dialer rate. Game changing for our IMO.",
      author: "Chief Distribution Officer",
      company: "National Life IMO",
    },
  },
  {
    slug: "health-insurance",
    index: "04",
    name: "Health Insurance",
    short: "Health",
    tagline: "Under-65 shoppers in and out of open enrollment.",
    description:
      "ACA, short-term medical, and private health prospects — qualified by household, subsidy eligibility and current coverage status. Compliant SEP and OEP traffic year round.",
    heroImage:
      "https://images.unsplash.com/photo-1514415008039-efa173293080",
    icon: "FirstAid",
    stats: [
      { value: "900K", label: "Annual lead volume" },
      { value: "AEP+SEP", label: "Year-round coverage" },
      { value: "55%", label: "Subsidy eligible" },
      { value: "3.1", label: "Avg. household size" },
    ],
    filters: [
      "Household size",
      "Estimated income (subsidy tier)",
      "Current coverage status",
      "Pre-existing conditions flag",
      "State & ZIP",
      "Preferred plan type (HMO/PPO)",
      "SEP qualifying life event",
    ],
    methodology: [
      "Compliance-first creative reviewed against CMS marketing guidelines.",
      "TCPA double opt-in with retained consent records for every lead.",
      "Carrier-aware appetite filters for FFM, SBM and off-exchange.",
    ],
    quote: {
      text: "We trust Citirex's compliance posture. That alone is worth the partnership.",
      author: "Head of Compliance",
      company: "National Health Brokerage",
    },
  },
  {
    slug: "medicare",
    index: "05",
    name: "Medicare",
    short: "Medicare",
    tagline: "T65 and aging-in beneficiaries, on a schedule.",
    description:
      "Medicare Advantage and Medicare Supplement leads from T65 prospects and seniors comparing plans. Built around AEP, OEP, SEP and lock-in cycles.",
    heroImage:
      "https://images.unsplash.com/photo-1514415008039-efa173293080",
    icon: "UserCircle",
    stats: [
      { value: "650K", label: "Annual lead volume" },
      { value: "T65", label: "Aging-in pipeline" },
      { value: "AEP", label: "Optimized for season" },
      { value: "98%", label: "Compliant consent" },
    ],
    filters: [
      "Age (T65 window)",
      "Current MA / MedSupp / Original",
      "Dual eligibility (D-SNP)",
      "Chronic conditions (C-SNP)",
      "Prescription drug usage",
      "Provider network preference",
      "County-level plan availability",
    ],
    methodology: [
      "PTC-compliant ad creative pre-approved against CMS Ch. 3 marketing rules.",
      "SOA-ready intake forms with full audit trails.",
      "T65 birthday-trigger campaigns running 8 months out from eligibility.",
    ],
    quote: {
      text: "The T65 pipeline Citirex built for us replaced two field marketing orgs at a fraction of the cost.",
      author: "SVP of Sales",
      company: "Medicare Advantage FMO",
    },
  },
  {
    slug: "final-expense",
    index: "06",
    name: "Final Expense",
    short: "Final Expense",
    tagline: "Seniors planning ahead for the people they leave behind.",
    description:
      "Whole-life final expense prospects ages 50–85, qualified by coverage need, health indication and beneficiary intent. Designed for telesales agencies.",
    heroImage:
      "https://images.pexels.com/photos/7927998/pexels-photo-7927998.jpeg",
    icon: "Flower",
    stats: [
      { value: "420K", label: "Annual lead volume" },
      { value: "50-85", label: "Age range" },
      { value: "68%", label: "Phone-answered" },
      { value: "$15K", label: "Median face amount" },
    ],
    filters: [
      "Age band",
      "Coverage amount sought",
      "Tobacco use",
      "Major health conditions",
      "Beneficiary identified",
      "Household income tier",
      "Spouse coverage interest",
    ],
    methodology: [
      "Direct response funnels tuned for senior audiences (large type, voice-first).",
      "Pre-qualified for graded vs. level plans to match carrier appetite.",
      "Live transfers from in-house call center to your licensed writing agents.",
    ],
    quote: {
      text: "Citirex understands the senior buyer. Their transfers feel like warm referrals, not cold leads.",
      author: "Owner",
      company: "Telesales Final Expense Agency",
    },
  },
  {
    slug: "solar",
    index: "07",
    name: "Solar",
    short: "Solar",
    tagline: "Homeowners ready to own their power bill.",
    description:
      "Homeowners with qualifying roof, utility provider and credit profile — actively requesting solar consultations. Compliant under TCPA and state-specific solar regulations.",
    heroImage:
      "https://images.pexels.com/photos/35726122/pexels-photo-35726122.jpeg",
    icon: "Sun",
    stats: [
      { value: "320K", label: "Annual lead volume" },
      { value: "$220", label: "Avg. monthly bill" },
      { value: "82%", label: "Homeowner verified" },
      { value: "30+", label: "Utility regions" },
    ],
    filters: [
      "Homeowner status (verified)",
      "Monthly utility spend",
      "Roof type, age & shading",
      "Credit tier (soft-pull)",
      "Utility provider",
      "State incentive eligibility",
      "Battery interest",
    ],
    methodology: [
      "Utility-bill-driven savings calculators capture pre-qualified intent.",
      "Roof and credit qualifiers run before submission — no tire kickers.",
      "Compliant TCPA capture with per-lead consent recordings.",
    ],
    quote: {
      text: "Best-in-class qualifier flow. Our setters spend their time closing, not screening.",
      author: "VP of Marketing",
      company: "Top-10 National Solar Installer",
    },
  },
  {
    slug: "home-services",
    index: "08",
    name: "Home Services",
    short: "Home Services",
    tagline: "Project-ready homeowners across every trade.",
    description:
      "Roofing, HVAC, windows, bath remodel, siding, gutters and more. Homeowners with project intent, budget and timeline — routed by ZIP to your nearest crew.",
    heroImage:
      "https://images.pexels.com/photos/16631149/pexels-photo-16631149.jpeg",
    icon: "Wrench",
    stats: [
      { value: "1.6M", label: "Annual lead volume" },
      { value: "11", label: "Trade verticals" },
      { value: "<2mi", label: "Avg. crew-to-lead" },
      { value: "70%", label: "Booked-appt rate" },
    ],
    filters: [
      "Project type (roof, HVAC, windows…)",
      "Timeline (0–30 / 1–3 / 3+ months)",
      "Budget band",
      "Homeowner status",
      "ZIP / service-area match",
      "Financing interest",
      "Insurance / cash project",
    ],
    methodology: [
      "Geo-fenced campaigns routed by ZIP to your nearest crew.",
      "Project-type qualifiers built per trade — never a generic home improvement form.",
      "Appointment-set leads available alongside data and live calls.",
    ],
    quote: {
      text: "Citirex moves the needle on appointment-set volume in ways no other vendor we've used can match.",
      author: "Director of Growth",
      company: "Regional Roofing & Exterior Contractor",
    },
  },
];

export const VERTICAL_BY_SLUG = Object.fromEntries(
  VERTICALS.map((v) => [v.slug, v]),
);
